import Vue from 'vue'
import Router from 'vue-router'

import LoginPage from '@/routes/LoginPage'
import ForgotPage from '@/routes/Forgot'
import RecoveryPage from '@/routes/Recovery'
import RegisterPage from '@/routes/RegisterPage'
import AuthPage from '@/routes/AuthPage'
import Admin from '@/routes/Admin'
import Lab from '@/routes/Lab'
import PhotoGrapher from '@/routes/PhotoGrapher'
import PhotoBuy from '@/routes/PhotoBuy'

import Main from '@/components/photographer/pages/Main'
import School from '@/components/photographer/pages/School'
import Year from '@/components/photographer/pages/Year'
import Event from '@/components/photographer/pages/Event'
import RegisterLink from '@/components/photographer/pages/RegisterLink'
import Parent from '@/components/photographer/pages/Parent'
import PhotographerOrder from '@/components/photographer/pages/Order'
import BasicSetting from '@/components/photographer/pages/BasicSetting'

import LabOrder from '@/components/lab/pages/Order'
import LabPhotographer from '@/components/lab/pages/Photographer'
import LabSetting from '@/components/lab/pages/Setting'

import AdminLab from '@/components/admin/pages/Lab'
import AdminSetting from '@/components/admin/pages/Setting'
import AdminOrder from '@/components/admin/pages/Order'
import AdminHierarchy from '@/components/admin/pages/Hierarchy'

import PhotoBuyMain from '@/components/photobuy/pages/Main'
import Mypage from '@/components/photobuy/pages/Mypage'
import Cart from '@/components/photobuy/pages/Cart'
import Order from '@/components/photobuy/pages/Order'
import Complete from '@/components/photobuy/pages/Complete'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/login',
            component: LoginPage
        },
        {
            path: '/forgot',
            component: ForgotPage
        },
        {
            path: '/recovery',
            component: RecoveryPage
        },
        {
            path: '/register',
            component: RegisterPage
        },
        {
            path: '/auth',
            component: AuthPage
        },
        {
            path: '/admin',
            component: Admin,
            children: [
                {
                    path: '',
                    component: AdminLab
                },
                {
                    path: 'setting',
                    component: AdminSetting
                },
                {
                    path: 'order',
                    component: AdminOrder
                },
                {
                    path: 'hierarchy',
                    component: AdminHierarchy
                }
            ]
        },
        {
            path: '/lab',
            component: Lab,
            children: [
                {
                    path: '',
                    component: LabOrder
                },
                {
                    path: 'photographer',
                    component: LabPhotographer
                },
                {
                    path: 'setting',
                    component: LabSetting
                }
            ]
        },
        {
            path: '/photographer',
            component: PhotoGrapher,
            children: [
                {
                    path: '',
                    component: Main
                },
                {
                    path: 'school',
                    component: School
                },
                {
                    path: 'school/:schoolId',
                    component: Year
                },
                {
                    path: 'school/:schoolId/:yearId',
                    component: Event
                },
                {
                    path: 'parent',
                    component: Parent
                },
                {
                    path: 'parent/registerLink',
                    component: RegisterLink
                },
                {
                    path: 'order',
                    component: PhotographerOrder
                },
                {
                    path: 'basicSetting',
                    component: BasicSetting
                }
            ]
        },
        {
            path: '/photobuy',
            component: PhotoBuy,
            children: [
                {
                    path: 'event/:id',
                    component: PhotoBuyMain
                },
                {
                    path: 'mypage',
                    component: Mypage
                },
                {
                    path: 'cart',
                    component: Cart
                },
                {
                    path: 'order',
                    component: Order
                },
                {
                    path: 'order/complete',
                    component: Complete
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js